import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';
import * as Papa from 'papaparse';
import * as d3 from 'd3';
import * as domtoimage from 'dom-to-image';
import * as _ from 'lodash';

/** Displays a dialog to download data from chart and an image */
@Component({
  selector: 'app-dialog-download',
  templateUrl: './dialog-download.component.html'
})
export class DialogDownloadComponent implements OnInit {
  /** Boolean to display loader */
  loadingImage: boolean;
  /** Boolean to display loader for svg  */
  loadingSVG: boolean;
  /** Dialog reference */
  dialogRef: MatDialogRef<DialogDownloadComponent>;
  /** Injected data */
  data: any;
  /** DOM sanitizer */
  domSanitizer: DomSanitizer;

  /** Init component, inject dialog ref and data */
  constructor(
    dialogRef: MatDialogRef<DialogDownloadComponent>,
    @Inject(MAT_DIALOG_DATA) data: any,
    domSanitizer: DomSanitizer) {
    this.dialogRef = dialogRef;
    this.data = data;
    this.domSanitizer = domSanitizer;
  }

  /** Init dialog default values call methods to download image and svg */
  ngOnInit(): void {
    this.loadingImage = false;
    const svg = d3.select('.empty-chart svg').node()['outerHTML'];
    const encoded = encodeURI(svg).replace('%3Csvg', '%3Csvg xmlns=\'http://www.w3.org/2000/svg\'');
    const r = 'data:image/svg+xml,' + encoded;
    this.data.rawSvg = r;
    this.data.svg = '';
    this.data.image = '';
    this.downloadImage();
    this.downloadSVG();
  }

  /** Close dialog */
  onNoClick(): void {
    this.dialogRef.close(this.data);
  }

  /** Sanitize url using domSanitizer */
  trust(data: string): SafeUrl {
    return this.domSanitizer.bypassSecurityTrustUrl(data);
  }

  /** Parse a blob to download image */
  parseBlob(dataUrl: string): string {
    dataUrl = dataUrl.replace('data:image/svg+xml;charset=utf-8,', '')
      .split('&quot;').join('\'').split('function (variable) {&%2310; ').join().split('%0A').join('');
    const blob = new Blob([dataUrl], { type: 'image/svg+xml' });
    const hrefURL = URL.createObjectURL(blob);
    return hrefURL;
  }

  /** Download screen as SVG */
  downloadSVG() {
    this.loadingSVG = true;
    d3.selectAll('.whole-wrapper .example-full-width .mat-form-field-label').style('display', 'none');
    d3.select('.whole-wrapper .charts-options').style('display', 'none');
    d3.select('.whole-wrapper .share-float-buttons').style('display', 'none');
    d3.select('.whole-wrapper .topic-filters').style('display', 'none');
    d3.select('.whole-wrapper .charts-wrapper .topic-filters').style('display', 'none');
    d3.select('.whole-wrapper .select-y-axis-wrapper p').style('display', 'none');
    d3.select('.whole-wrapper .select-x-axis-wrapper p').style('display', 'none');
    d3.selectAll('.whole-wrapper .material-icons').style('display', 'none');
    d3.select('.whole-wrapper .share-float-buttons .whatsapp').attr('href', null);
    const href = d3.select('.whole-wrapper .share-float-buttons .whatsapp').attr('href');

    if (!d3.selectAll('.whole-wrapper .topic-filters').select('.flex-100').select('.cvnl-logo').node()) {
      d3.selectAll('.whole-wrapper .topic-filters').select('.flex-100')
        .append('img')
        .attr('src', 'assets/images/cvnl-logo.png')
        .attr('class', 'cvnl-logo')
        .style('max-width', '81px')
        .style('height', 'auto')
        .style('float', 'left');
    }

    let element = d3.select('.whole-wrapper').node();
    if (element) {
      domtoimage.toSvg(element, { quality: 1, bgcolor: 'white', filter: this.filter })
        .then(function (dataUrl) {
          d3.selectAll('.whole-wrapper .example-full-width .mat-form-field-label').style('display', null);
          d3.select('.whole-wrapper .charts-options').style('display', null);
          d3.select('.whole-wrapper .share-float-buttons').style('display', null);
          d3.select('.whole-wrapper .topic-filters').style('display', null);
          d3.select('.whole-wrapper .charts-wrapper .topic-filters').style('display', null);
          d3.select('.whole-wrapper .select-y-axis-wrapper p').style('display', null);
          d3.select('.whole-wrapper .select-x-axis-wrapper p').style('display', null);
          d3.selectAll('.whole-wrapper .material-icons').style('display', null);
          d3.select('.whole-wrapper .share-float-buttons .whatsapp').attr('href', href);
          d3.selectAll('.filters-info .layout-row').style('display', 'grid');
          d3.selectAll('.filters-info').style('margin-top', '20px');
          d3.selectAll('.content-graphs').style('margin-top', '30px');
          d3.selectAll('.whole-wrapper .topic-filters').select('.flex-100').select('.cvnl-logo').remove();
          this.data.svg = dataUrl;
          this.data.svgHref = this.trust(this.parseBlob(this.data.svg));
          this.loadingSVG = false;

        }.bind(this))
        .catch(function (err) {
          console.error('Error creating domtoimage.toSvg()');
          console.error(err);
          d3.selectAll('.whole-wrapper .example-full-width .mat-form-field-label').style('display', null);
          d3.select('.whole-wrapper .charts-options').style('display', null);
          d3.select('.whole-wrapper .share-float-buttons').style('display', null);
          d3.select('.whole-wrapper .topic-filters').style('display', null);
          d3.select('.whole-wrapper .charts-wrapper .topic-filters').style('display', null);
          d3.select('.whole-wrapper .select-y-axis-wrapper p').style('display', null);
          d3.select('.whole-wrapper .select-x-axis-wrapper p').style('display', null);
          d3.selectAll('.whole-wrapper .material-icons').style('display', null);
          d3.select('.whole-wrapper .share-float-buttons .whatsapp').attr('href', href);
          d3.selectAll('.filters-info .layout-row').style('display', null);
          d3.selectAll('.filters-info').style('margin-top', '0px');
          d3.selectAll('.content-graphs').style('margin-top', '0px');
          d3.selectAll('.whole-wrapper .topic-filters').select('.flex-100').select('.cvnl-logo').remove();
          // If something went wrong, download SVG as JPG
          element = d3.select('.empty-chart svg').node();
          const canvas = document.createElement('canvas');
          canvas.setAttribute('width', element['clientWidth']);
          canvas.setAttribute('height', element['clientHeight']);
          const ctx = canvas.getContext('2d');
          const image = new Image();
          image.onload = function () {
            ctx.drawImage(image, 0, 0, element['clientWidth'], element['clientHeight']);
            this.data.svg = canvas.toDataURL();
            this.data.svgHref = this.trust(this.parseBlob(this.data.svg));
            this.loadingSVG = false;

          }.bind(this);
          image.src = this.data.rawSvg; // Current svg
        }.bind(this));
    }
  }

  /**
   * Filter DOM node, use only visible nodes
   * @param node DOM node reference
   */
  filter(node): boolean {
    return !(node.style && node.style.display === 'none');
  }

  /** Download screen as an image */
  downloadImage() {
    this.loadingImage = true;
    d3.select('.whole-wrapper .charts-options').style('display', 'none');
    d3.select('.whole-wrapper .share-float-buttons').style('display', 'none');
    d3.select('.whole-wrapper .topic-filters').style('display', 'none');
    d3.select('.whole-wrapper .charts-wrapper .topic-filters').style('display', 'none');
    d3.select('.whole-wrapper .select-y-axis-wrapper p').style('display', 'none');
    d3.select('.whole-wrapper .select-x-axis-wrapper p').style('display', 'none');
    d3.selectAll('.whole-wrapper .material-icons').style('display', 'none');
    d3.select('.whole-wrapper .share-float-buttons .whatsapp').attr('href', null);
    d3.selectAll('.filters-info .layout-row').style('display', 'grid');
    d3.selectAll('.content-graphs').style('margin-top', '30px');
    d3.selectAll('.filters-info').style('margin-top', '20px');
    d3.selectAll('.grey-line').style('display', 'none');
    const href = d3.select('.whole-wrapper .share-float-buttons .whatsapp').attr('href');

    if (!d3.selectAll('.whole-wrapper .topic-filters').select('.flex-100').select('.cvnl-logo').node()) {
      d3.selectAll('.whole-wrapper .topic-filters').select('.flex-100')
        .append('img')
        .attr('src', 'assets/images/cvnl-logo.png')
        .attr('class', 'cvnl-logo')
        .style('max-width', '81px')
        .style('height', 'auto')
        .style('float', 'left');
    }

    let element = d3.select('.whole-wrapper').node();
    if (element) {
      domtoimage.toJpeg(element, { quality: 0.95, bgcolor: 'white', filter: this.filter })
        .then(function (dataUrl) {
          d3.select('.whole-wrapper .charts-options').style('display', null);
          d3.select('.whole-wrapper .share-float-buttons').style('display', null);
          d3.select('.whole-wrapper .topic-filters').style('display', null);
          d3.select('.whole-wrapper .charts-wrapper .topic-filters').style('display', null);
          d3.select('.whole-wrapper .select-y-axis-wrapper p').style('display', null);
          d3.select('.whole-wrapper .select-x-axis-wrapper p').style('display', null);
          d3.selectAll('.whole-wrapper .material-icons').style('display', null);
          d3.select('.whole-wrapper .share-float-buttons .whatsapp').attr('href', href);
          d3.selectAll('.filters-info .layout-row').style('display', null);
          d3.selectAll('.content-graphs').style('margin-top', '0px');
          d3.selectAll('.filters-info').style('margin-top', '0px');
          d3.selectAll('.grey-line').style('display', null);
          d3.selectAll('.whole-wrapper .topic-filters').select('.flex-100').select('.cvnl-logo').remove();
          this.data.image = dataUrl;
          this.loadingImage = false;
        }.bind(this))
        .catch(function (err) {
          console.error('Error creating domtoimage.toJpeg()');
          console.error(err);
          d3.select('.whole-wrapper .charts-options').style('display', null);
          d3.select('.whole-wrapper .share-float-buttons').style('display', null);
          d3.select('.whole-wrapper .topic-filters').style('display', null);
          d3.select('.whole-wrapper .charts-wrapper .topic-filters').style('display', null);
          d3.select('.whole-wrapper .select-y-axis-wrapper p').style('display', null);
          d3.select('.whole-wrapper .select-x-axis-wrapper p').style('display', null);
          d3.selectAll('.whole-wrapper .material-icons').style('display', null);
          d3.select('.whole-wrapper .share-float-buttons .whatsapp').attr('href', href);
          d3.selectAll('.whole-wrapper .topic-filters').select('.flex-100').select('.cvnl-logo').remove();
          // If something went wrong, download SVG as JPG
          element = d3.select('.empty-chart svg').node();
          const canvas = document.createElement('canvas');
          canvas.setAttribute('width', element['clientWidth']);
          canvas.setAttribute('height', element['clientHeight']);
          const ctx = canvas.getContext('2d');
          const image = new Image();
          image.onload = function () {
            ctx.drawImage(image, 0, 0, element['clientWidth'], element['clientHeight']);
            this.data.image = canvas.toDataURL();
            this.loadingImage = false;
          }.bind(this);
          image.src = this.data.rawSvg; // Current svg
        }.bind(this));
    }
  }

  /** Download data in a CSV file */
  downloadCSV() {
    const copyCSVdata = this.processCSVdata(_.cloneDeep(this.data.dataToDraw));
    let i = '"' + this.data.cleanTitle + '" \n';
    i += Papa.unparse(copyCSVdata);
    i += '\nFuente: Estimaciones de Conapred con base en la ' + this.data.source;
    i += '\n' + this.data.filters;
    i = 'data:text/csv;charset=utf-8,' + i;
    const r = encodeURI(i);
    const s = document.createElement('a');
    s.setAttribute('href', r);
    s.setAttribute('download', this.data.title);
    s.dispatchEvent(new MouseEvent(`click`, {
      bubbles: true,
      cancelable: true,
      view: window
    }));
  }

  /** Format CSV data, change column names */
  processCSVdata(array) {
    // Go through all objects
    array.forEach(obj => {
      for (const key in obj) {
        if (typeof obj[key] === 'number') {
          obj[key] = parseFloat(obj[key].toFixed(2));
        }
      }
      this.replaceKeyInObj(obj, 'categories', 'Categorias');
      this.replaceKeyInObj(obj, 'FACTOR_COE', 'Total');
      this.replaceKeyInObj(obj, 'RANGO_EDAD', 'Rango edad');
      this.replaceKeyInObj(obj, 'FACTOR_IND', 'Total');
      this.replaceKeyInObj(obj, 'coefficient', 'Coeficiente de variación');
      this.replaceKeyInObj(obj, 'columns', 'Columnas');
      this.replaceKeyInObj(obj, 'FACTOR_DIS', 'Total');
      this.replaceKeyInObj(obj, 'FACTOR_REL', 'Total');
      this.replaceKeyInObj(obj, 'FACTOR_ADU', 'Total');
      this.replaceKeyInObj(obj, 'FACTOR_NIN', 'Total');
      this.replaceKeyInObj(obj, 'FACTOR_ADO', 'Total');
      this.replaceKeyInObj(obj, 'FACTOR_MUJ', 'Total');
      this.replaceKeyInObj(obj, 'FACTOR_SDE', 'Total');

      for (const key in obj) {
        if (key) {
          const oldKey = key;
          // Look for coefficient in keys
          if (key.includes('coefficient')) {
            // Generate new key name
            const newKey = key.replace('coefficient', ' Coeficiente de variación');
            this.replaceKeyInObj(obj, oldKey, newKey);
          }
        }
      }
      delete obj.totalByGroup;
    });
    array = this.sortData(array);
    return array;
  }

  /** Replace key in object with a new name */
  replaceKeyInObj(obj: {}, oldKey: string, newKey: string) {
    if (obj.hasOwnProperty(oldKey)) {
      // Get value from old key
      obj[newKey] = obj[oldKey];
      // Erase old key
      delete obj[oldKey];
    }
  }

  /** Sort data */
  sortData(data) {
    // Sort content
    const salaries = ['Sin ingresos',
      'Menos de 1 Salario mínimo',
      '1-2 Salarios mínimos',
      '2-3 Salarios mínimos',
      '3-4 Salarios mínimos',
      '4-5 Salarios mínimos',
      '5-6 Salarios mínimos',
      '6-7 Salarios mínimos',
      'Más de 7 Salarios mínimos',
      '8-9 Salarios mínimos',
      '9-10 Salarios mínimos',
      '10 o más Salarios mínimos'];

    const situation = [
      'Siempre',
      'Algunas veces',
      'Pocas veces',
      'Nunca',
      'No responde'];

    const education = [
      'Sin escolaridad',
      'Preescolar',
      'Primaria incompleta',
      'Primaria',
      'Secundaria incompleta',
      'Secundaria',
      'Media superior',
      'Superior',
      'No sabe'];

    const frequency = [
      'Mucho',
      'Algo',
      'Poco',
      'Nada',
      'No Sabe',
      'No aplica'];

    const estrato = [
      'Alto',
      'Medio alto',
      'Medio bajo',
      'Bajo'];

    const skinColor = [
      'Más obscuro',
      'Intermedio',
      'Más claro'
    ];

    const orderedData = [];

    data.forEach(function (obj) {
      const ordered = {};
      Object.keys(obj).sort(function (a, b) {
        if (_.includes(salaries, a) && _.includes(salaries, b)) {
          return salaries.indexOf(a) - salaries.indexOf(b);
        } else if (_.includes(situation, a) && _.includes(situation, b)) {
          return situation.indexOf(a) - situation.indexOf(b);
        } else if (_.includes(education, a) && _.includes(education, b)) {
          return education.indexOf(a) - education.indexOf(b);
        } else if (_.includes(frequency, a) && _.includes(frequency, b)) {
          return frequency.indexOf(a) - frequency.indexOf(b);
        } else if (_.includes(estrato, a) && _.includes(estrato, b)) {
          return estrato.indexOf(a) - estrato.indexOf(b);
        } else if (_.includes(skinColor, a) && _.includes(estrato, b)) {
          return skinColor.indexOf(a) - skinColor.indexOf(b);
        } else if (a === 'RANGO_EDAD' && b === 'RANGO_EDAD') {
          return a.localeCompare(b, undefined, { numeric: true });
        } else if (_.includes(data.map(o => o), 'Sí')) {
          const res = ['No', 'Sí'];
          if ((res.indexOf(a) * -1) < (res.indexOf(b) * -1)) {
            return -1;
          } else {
            return 1;
          }
        } else if (a === 'Otro' || a === 'No sabe' || a === 'No aplica') {
          return 1;
        } else if (b === 'Otro' || b === 'No sabe' || b === 'No aplica') {
          return -1;
        } else {
          if (!Number.isNaN(+a) && !Number.isNaN(+b)) {
            // If both values are numbers use numeric value
            return Number(a) - Number(b);
          } else if (!Number.isNaN(+a) && Number.isNaN(+b)) {
            return -1;
          } else if (Number.isNaN(+a) && !Number.isNaN(+b)) {
            return 1;
          } else if (a < b) {
            return -1;
          } else if (a > b) {
            return 1;
          }
        }
        return 0;
      }).forEach(function (key) {
        ordered[key] = obj[key];
      });
      orderedData.push(ordered);
    });

    return orderedData;
  }
}



// WEBPACK FOOTER //
// ./src/app/dialogs/dialog-download/dialog-download.component.ts